/* eslint-disable @typescript-eslint/no-explicit-any */

import type {
  SearchBarClickedAttributes,
  SearchErrorShownAttributes,
  ShopImpressionsLoadedAttributes,
  ShopListUpdatedAttributes,
} from '@glovo/perseus-events-perseus'
import { analytics } from '@/tools/analytics'

export const searchBarClickedEvent = (attributes: SearchBarClickedAttributes) => {
  analytics.trackEvent('SearchBarClickedEvent', attributes as any)
}

export const searchErrorShownEvent = (attributes: SearchErrorShownAttributes) => {
  analytics.trackEvent('SearchErrorShownEvent', attributes as any)
}

export const shopImpressionsLoadedEvent = (attributes: ShopImpressionsLoadedAttributes) => {
  analytics.trackEvent('ShopImpressionsLoadedEvent', attributes as any)
}

export const shopListUpdatedEvent = (attributes: ShopListUpdatedAttributes) => {
  analytics.trackEvent('ShopListUpdatedEvent', attributes as any)
}
